import { ReactElement } from 'react'
import BaixarPdfBoletoDepositoImpl from 'modules/pagamentos/domain/usecases/BaixarPdfBoletoDeposito'
import GerarBoletoDepositoImpl from 'modules/pagamentos/domain/usecases/GerarBoletoDeposito'
import ListaBoletosDepositoImpl from 'modules/pagamentos/domain/usecases/ListaBoletosDeposito'
import ListaContaEscrowImpl from 'modules/pagamentos/domain/usecases/ListaContaEscrow'
import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'
import TrazerDinheiro from 'modules/pagamentos/pages/Pagamento/components/TrazerDinheiro'

export const TrazerDinheiroFactory = (): ReactElement => {
  const pagamentoRepository = new PagamentoRepository()
  const gerarBoletoDeposito = new GerarBoletoDepositoImpl(pagamentoRepository)
  const listaBoletosDeposito = new ListaBoletosDepositoImpl(pagamentoRepository)
  const baixarPdfBoletoDeposito = new BaixarPdfBoletoDepositoImpl(
    pagamentoRepository,
  )
  const listaContaEscrow = new ListaContaEscrowImpl(pagamentoRepository)

  return (
    <TrazerDinheiro
      gerarBoletoDeposito={gerarBoletoDeposito}
      baixarPdfBoletoDeposito={baixarPdfBoletoDeposito}
      listaBoletosDeposito={listaBoletosDeposito}
      listaContaEscrow={listaContaEscrow}
    />
  )
}
